import React, { useState } from 'react';
import './FAQ.scss';

const FAQS = [
  ['Is the 17.5% the only thing Go4 charges?', 'Yes. There is no subscription, no posting fee, no placement premium and no annual platform cost. You pay the trainer\u2019s rate plus 17.5% of that rate, and nothing else.'],
  ['Who decides the hourly rate?', 'You do. Go4 never sets or negotiates pay. The averages shown by ZIP are historical — what trainers in that state have actually accepted and worked jobs for — so you can price competitively without guessing.'],
  ['When am I actually charged?', 'After the shift is worked. Posting a job, reviewing applicants and drafting an event all cost nothing, and a job that is never filled is never billed.'],
  ['What happens if nobody accepts my job?', 'You pay nothing. If the rate isn\u2019t attracting applicants, you can raise it and the fee recalculates on the new rate — the percentage never changes.'],
  ['What if I need to cancel after a trainer is confirmed?', 'Cancellations made within 72 hours of an event that has one or more confirmed ATs incur a cancellation fee: 25% of the shift cost between 25 and 72 hours out, and 50% within 24 hours. Cancel more than 73 hours ahead and you owe only the Go4 service fee for the canceled position. Weather-related cancellations are excluded, and appeals for extenuating circumstances can be submitted to Go4 Support within 72 hours of the cancellation.'],
  ['Does the fee change for multi-day or multi-trainer events?', 'No. It\u2019s 17.5% of total trainer pay whether that\u2019s one four-hour shift or twelve trainers across a weekend tournament.'],
  ['Are trainers employees or contractors?', 'Athletic trainers on Go4 are independent contractors. Go4 handles 1099 distribution, payment processing and professional liability coverage as part of the service fee.'],
];

const FAQ = () => {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="pl-faq">
      <div className="pl-faq__inner">
        <h2 className="pl-faq__title">Pricing questions</h2>
        <div className="pl-faq__list">
          {FAQS.map(([q, a], i) => {
            const isOpen = open === i;
            return (
              <div key={q} className="pl-faq__item">
                <button type="button" className="pl-faq__q" onClick={() => setOpen(isOpen ? -1 : i)}>
                  <span className="pl-faq__q-text">{q}</span>
                  <span className="pl-faq__icon">
                    {isOpen ? (
                      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round"><path d="M5 12h14" /></svg>
                    ) : (
                      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round"><path d="M12 5v14M5 12h14" /></svg>
                    )}
                  </span>
                </button>
                {isOpen && <p className="pl-faq__a">{a}</p>}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
